window.onload = (event) => {

  const body = document.querySelector('body');
  const buyNowModal = document.querySelector('#buynow-modal');
  const buyNowCloseButton = document.querySelector('.buynow-modal-close-link');
  const buyNowModalContent = document.querySelector('.buynow-modal-content');
  const buyButton = document.querySelector('.btn--buynow');

  buyButton.addEventListener('click', e => {
    e.preventDefault();

    body.classList.add('show-buynow-modal');
    buyNowModal.classList.add('show');
  });

  document.addEventListener('keydown', e => {
    if (buyNowModal.classList.contains('show') == true && e.key == 'Escape') {
      buyNowModal.classList.remove('show');
      body.classList.remove('show-buynow-modal');
    }
  });

  document.addEventListener('click', e => {
    if (e.target.classList.contains('btn--buynow') == false && buyNowModal.classList.contains('show') == true) {
      const isClickInside = buyNowModalContent.contains(e.target)
    
      if (!isClickInside) {
        buyNowModal.classList.remove('show');
        body.classList.remove('show-buynow-modal');
      }
    }
  });

  buyNowCloseButton.addEventListener('click', e => {
    e.preventDefault();

    buyNowModal.classList.remove('show');
    body.classList.remove('show-buynow-modal');
  });
  
};
